export default function() {
  return window &&
    window.performance &&
    window.performance.navigation &&
    window.performance.navigation.type === 1;
}



// WEBPACK FOOTER //
// ./client/app/common/utils/isReloaded.js